import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

const optionsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })
);

const tournamentType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  matches: optionsPropTypes.isRequired,
  title: PropTypes.string.isRequired,
});

const propTypes = exact({
  allOptionText: PropTypes.string,
  tournaments: PropTypes.arrayOf(tournamentType).isRequired,
  selectedTournaments: PropTypes.arrayOf(PropTypes.string),
  handleReset: PropTypes.func.isRequired,
  handleValueChange: PropTypes.func.isRequired,
});

const defaultProps = {
  allOptionText: 'All',
  selectedTournaments: [],
};

class FilterTournament extends Component {
  constructor(props) {
    super(props);

    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleTournamentSelect = this.handleTournamentSelect.bind(this);

    const defaultTournaments =
      props.tournaments.length === props.selectedTournaments.length
        ? []
        : props.selectedTournaments;
    this.state = { tournaments: defaultTournaments };
  }

  componentDidUpdate() {
    this.handleTournamentUpdate();
  }

  handleTournamentUpdate() {
    const allSelected = this.props.selectedTournaments.length === this.props.tournaments.length;
    if (
      !allSelected &&
      !this.state.tournaments.length &&
      this.state.tournaments.length !== this.props.selectedTournaments.length
    ) {
      this.setState({
        tournaments: this.props.selectedTournaments,
      });
    } else if (allSelected && this.state.tournaments.length) {
      this.setState({
        tournaments: [],
      });
    }
  }

  handleTournamentSelect(id) {
    let tournaments = this.state.tournaments || [];
    const removeItem = tournaments.includes(id);

    if (removeItem) tournaments = tournaments.filter((tournament) => !id.includes(tournament));
    else tournaments.push(id);

    this.setState({ tournaments });
    this.props.handleValueChange({ tournaments });
  }

  /**
   * reset informs parent whereby reset is called to below.
   */
  handleResetClick() {
    this.props.handleReset();
  }

  /**
   * state is reset from parent, this is because state is managed in this component.
   */
  reset() {
    this.setState({ tournaments: [] });
  }

  render() {
    const allButtonClass = classNames('PackageFilter_button', 'Button', {
      active: this.state.tournaments.length === 0,
    });

    return (
      <form className="PackageFilter">
        <div className="PackageFilter_fieldset">
          <div className="PackageFilter_field">
            <div className="PackageFilter_input">
              <button type="button" className={allButtonClass} onClick={this.handleResetClick}>
                {this.props.allOptionText}
              </button>
            </div>
          </div>
          {this.props.tournaments.map((tournament) => (
            <div className="PackageFilter_field PackageFilter_field-flex" key={tournament.id}>
              <div className="PackageFilter_input">
                <button
                  type="button"
                  className={`PackageFilter_button Button ${
                    this.state.tournaments.includes(tournament.id) ? 'active' : ''
                  }`}
                  onClick={() => this.handleTournamentSelect(tournament.id)}
                >
                  {tournament.title}
                </button>
              </div>
            </div>
          ))}
        </div>
      </form>
    );
  }
}

FilterTournament.propTypes = propTypes;
FilterTournament.defaultProps = defaultProps;

export default FilterTournament;
